(()=>{const roots=()=>document.querySelectorAll('[data-hxtp-root]');

const rawLabel=el=>(el?.tagName==='INPUT'?el.value:(el?.textContent||el?.getAttribute?.('aria-label')||'')).replace(/\s+/g,' ').trim();
const lowerLabel=el=>rawLabel(el).toLowerCase();

const isBookControl=el=>[
  'select date & time',
  'select date and time',
  'book your time',
  'choose your time',
  'select a time',
  'book time',
  'choose date & time',
  'choose date and time'
].some(label=>lowerLabel(el).includes(label));

const init=root=>{
  if(root.dataset.hxtpBookingReady)return;
  root.dataset.hxtpBookingReady='true';

  const slot=root.querySelector('[data-hxtp-book-slot]');
  const errorBox=root.querySelector('[data-hxtp-book-error]');
  const select=root.querySelector('[data-hxtp-variant]');
  const submit=root.querySelector('[data-hxtp-submit]');
  const form=submit?.closest('form');

  const clearError=()=>{
    if(!errorBox)return;
    errorBox.textContent='';
    errorBox.hidden=true;
  };

  const isDateError=text=>{
    const value=(text||'').replace(/\s+/g,' ').trim().toLowerCase();
    return [
      'select date and time',
      'select date & time',
      'please select date and time',
      'please select date & time',
      'select a date and time',
      'select a date & time'
    ].some(message=>value===message||value.includes(message));
  };

  const relocateError=()=>{
    if(!slot||!errorBox)return false;
    const scope=slot.parentElement||slot;
    const candidates=[...scope.querySelectorAll('[role="alert"],[aria-live="assertive"],[class*="error" i],[class*="validation" i],small,span,p,div')]
      .filter(el=>{
        if(el===errorBox||errorBox.contains(el))return false;
        if(el.matches('button,a,[role="button"],input,select'))return false;
        return isDateError(rawLabel(el));
      });

    if(!candidates.length)return false;
    errorBox.textContent=rawLabel(candidates[0])||'Select date and time';
    errorBox.hidden=false;
    candidates.forEach(el=>{
      el.hidden=true;
      el.setAttribute('aria-hidden','true');
    });
    return true;
  };

  const scheduleErrorCheck=()=>{
    [0,50,120,220,400,700,1100].forEach(delay=>setTimeout(relocateError,delay));
  };

  const refresh=()=>{
    if(!select)return;
    const option=select.selectedOptions[0];
    if(!option)return;

    root.querySelectorAll('[data-hxtp-price]').forEach(node=>{
      const next=option.dataset.price||'';
      if(node.textContent!==next)node.textContent=next;
    });

    if(submit){
      const unavailable=option.dataset.available!=='true';
      submit.disabled=unavailable;
      const label=submit.querySelector('[data-hxtp-submit-label]');
      const nextLabel=unavailable?'Unavailable':'Continue to payment';
      if(label&&label.textContent!==nextLabel)label.textContent=nextLabel;
    }
  };

  const placeBookControl=()=>{
    if(!slot)return false;

    const existing=slot.querySelector('button,a,[role="button"],input[type="button"],input[type="submit"]');
    if(existing&&isBookControl(existing)){
      slot.classList.add('has-bookx');
      return true;
    }

    const candidates=[...document.querySelectorAll('button,a,[role="button"],input[type="button"],input[type="submit"]')]
      .filter(el=>{
        if(el.classList.contains('hxtp-bookx__placeholder'))return false;
        if(!isBookControl(el))return false;
        if(el.matches('[data-hxtp-submit]'))return false;
        if(el.closest('[data-hxtp-root]')&&el.closest('[data-hxtp-root]')!==root)return false;
        if(el.closest('[data-hxtp-explore-dialog]'))return false;
        return true;
      });

    if(!candidates.length)return false;
    const control=candidates.find(el=>slot.contains(el))||candidates[candidates.length-1];
    if(control&&!slot.contains(control))slot.appendChild(control);
    if(control){
      const desiredLabel='Select Date & Time';
      if(control.tagName==='INPUT'){
        control.value=desiredLabel;
      }else{
        const textNode=[...control.childNodes].find(node=>node.nodeType===Node.TEXT_NODE&&node.textContent.trim());
        if(textNode){
          textNode.textContent=desiredLabel;
        }else if(control.children.length===0){
          control.textContent=desiredLabel;
        }else{
          const labelNode=control.querySelector('span,[class*="label" i]');
          if(labelNode)labelNode.textContent=desiredLabel;
        }
      }
      control.setAttribute('aria-label',desiredLabel);
      slot.dataset.hxtpBookLabel=desiredLabel;
    }
    slot.classList.add('has-bookx');
    return true;
  };

  refresh();

  select?.addEventListener('change',()=>{
    clearError();
    refresh();
    setTimeout(placeBookControl,120);
  });

  slot?.addEventListener('click',clearError);
  slot?.addEventListener('keydown',clearError);
  submit?.addEventListener('click',scheduleErrorCheck);
  form?.addEventListener('submit',scheduleErrorCheck);

  if(!placeBookControl()){
    [180,500,1000,1800,3000,5000,8000].forEach(delay=>{
      setTimeout(()=>{
        if(!slot?.classList.contains('has-bookx'))placeBookControl();
      },delay);
    });
  }
};

const run=()=>roots().forEach(init);

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',run,{once:true});
}else{
  run();
}

document.addEventListener('shopify:section:load',run);
})();